import * as React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Address, Order } from './iMonCompte';
import { renderAlert, renderFilArianne, renderTitleH1 } from './RenderCommon';
import { getUserId, sessionExpire } from './MonCompteAction';
import { formatTelephone } from './AddressAction';
import Modal from 'react-responsive-modal';
import Icons from './Icons';
import {getHostApi, getRequestConfig, initEvent} from '../../utils';

interface RenderAddressesState {
  addresses: Address[];
  open: boolean;
  showAlert: boolean;
  textAlert: string;
  classAlert: string;
  addressId: string;
  orders?: Order[];
  pending: boolean;

}

export default class RenderAddresses extends React.Component<Record<string, unknown>, RenderAddressesState> {
  constructor(props: Record<string, unknown>) {
    super(props);
    this.state = {
      addresses: [],
      open: false,
      showAlert: false,
      textAlert: 'Votre adresse a bien été mise à jour',
      classAlert: 'alert-success',
      addressId: '',
      pending: false,
    };
  }

  componentDidMount() {
    this._getAllAddressesByCustomer();
    this._getAllOrdersByCustomer();
  }

  /**
   * Fonction retournant toutes les commandes de l'utilisateur conecté
   *
   * @returns {Order[]}
   * @private
   */
  _getAllOrdersByCustomer() {
    const url = `${getHostApi()}/customers/${getUserId()}/orders/`;

    axios.get(url, getRequestConfig()).then((response) => {
      if (response.data.orders) {
        this.setState({ orders: response.data.orders }, () => {
          this._definePendingOrder();
        });
      }
    }).catch((error) => {
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  _definePendingOrder = () => {
    for (const order of this.state.orders || []) {
      if (order.StatutCommande < '7') {
        this.setState({ pending: true });
        break;
      }
    }
  }

  /**
   * Fonction retournant toutes les adresses de l'utilisateur conecté
   *
   * @returns {Order[]}
   * @private
   */
  _getAllAddressesByCustomer() {
    document.dispatchEvent(initEvent('dp-loading'));
    axios.get(`${getHostApi()}/customers/${getUserId()}/addresses`, getRequestConfig())
      .then((response) => {
      document.dispatchEvent(initEvent('dp-loaded'));
      if (response.data.addresses) {
        this.setState({ addresses: response.data.addresses });
      }
    }).catch((error) => {
      document.dispatchEvent(initEvent('dp-loaded'));
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  /**
   * Fonction supprimant une adresse de l'utilisateur connecté
   *
   * @param {string} addresseId
   * @private
   */
  _deleteAddress = () => {
    this.onCloseModal();
    axios.delete(`${getHostApi()}/customers/${getUserId()}/addresses/${this.state.addressId}`, getRequestConfig())
      .then((response) => {
      this._getAllAddressesByCustomer();
      this.setState({
        showAlert: true,
        textAlert: 'Votre adresse a bien été supprimée !',
        classAlert: 'alert-success',
      });
    }).catch((error) => {
      console.log(error);
      this.setState({
        showAlert: true,
        textAlert: 'Une erreur est survenue pendant la suppression de votre adresse !',
        classAlert: 'alert-danger',
      });
    });
  }

  onClickButton = (event: React.MouseEvent<HTMLButtonElement>, addressId: string) => {
    // event.preventDefault();
    this.setState({ addressId: addressId });
    this.onOpenModal();
  }

  onOpenModal = () => {
    this.setState({ open: true });
  }

  onCloseModal = () => {
    this.setState({ open: false });
  }

  _renderModal = () => {
    return (
      <Modal open={this.state.open} onClose={this.onCloseModal} center
             classNames={{ overlay: 'bootstrap-container', modal: 'deleteAddressModalContainer customModal',
               closeButton: 'deleteAddressModalCloseButton closeButton'}}>
        <div className="modalOrder p-2 pa0Mobile">
          <p className="font18 text-center">Etes-vous sûr de vouloir supprimer cette adresse ?</p>

          <button title="Annuler" onClick={this.onCloseModal}
                  className="border-0 bold bg-white cursor-pointer btnCancelModal reset-button buttonFourth float-left py-2 px-3">
            Non
          </button>
          <button title="Supprimer l'adresse" onClick={this._deleteAddress}
                  className="border border-dark bold bg-white cursor-pointer btnValidateModal reset-button buttonFourth float-right py-2 px-3">
            Oui
          </button>
        </div>
      </Modal>
    );
  }

  render() {
    const renderIsFavorite = (isFavorite: number) => {
      if (isFavorite == 1) {
        return (
          <div className="col-md-1 col1 p-0">
            <div className="heart icon">
              <Icons icon="favorite" size={15} title="Adresse favorite" color="black"/>
            </div>
          </div>
        );
      }
    };

    const renderIsFacturation = (isFacturation: number) => {
      if (isFacturation == 1) {
        return (
          <div className="col-md-12 p-0 mt-1 italic grey col-6">
            Adresse de facturation </div>
        );
      }
      return (
        <div className="col-md-12 p-0 mt-1 italic grey col-6">
          Adresse de livraison </div>
      );
    };

    const renderLibelle = (libelle: string, isFacturation: number, isFavorite: number) => {
      return (
        <div className={'col-md-3 col-3 pl-0 pa0Mobile flex-column flex-row-mobile libelleAdresseCarnet' +
        ' align-items-center'}>
          <div className="d-flex align-items-center col-6 col-md-12 p-0">
            {renderIsFavorite(isFavorite)}
            <span className="font16 bold pl-2 libelleAdresse pa0Mobile col-md-11 col-10">{libelle}</span>
          </div>
          {renderIsFacturation(isFacturation)}
        </div>
      );
    };

    const renderEditAddress = (addressId: string) => {
      return (
        <span className="pr-1">
          <Link to={`/addresses/address/${addressId}`} title="Editer l'adresse">
            <Icons icon="edit_address" size={15} color="black"/>
          </Link>
        </span>
      );
    };

    const renderDeleteAddress = (address: Address) => {
      return (
        <span>
            <button title="Supprimer l'adresse" onClick={event => this.onClickButton(event, address.id)} id={address.id}
                    className="cursor-pointer border-0 p-0 bg-transparent">
              <Icons icon="delete_address" size={15} color="black" title="Supprimer l'adresse"/>
            </button>
          {this._renderModal()}
          </span>
      );
    };

    const renderAddressAction = (address: Address) => {
      return (
        <div className="col-md-2 col-1 p-0 text-right">
          {renderEditAddress(address.id)}
          {renderDeleteAddress(address)}
        </div>
      );

    };

    const renderTelephone = (fixe: string, mobile: string) => {
      if (mobile != null && mobile != '') {
        return (
          <span>Tél: {formatTelephone(mobile)}</span>
        );
      }
      return (
        <span>Tél: {formatTelephone(fixe)}</span>
      );
    };

    const renderAddressStreet = (address: Address) => {
      return (
        <div className="col-md-4 col-5 pa0Mobile">
          <div>{address.societe}</div>
          <div>{address.adresse}</div>
          <div>{address.adresse2}</div>
          <div>{address.adresse3}</div>
          <div>
            <span>{address.code_postal}&nbsp;</span>
            <span>{address.ville},&nbsp;</span>
            <span>{address.pays.Libelle}</span>
          </div>
          <div className="adresseTelephone">{renderTelephone(address.telephone_fixe, address.telephone_mobile)}</div>
        </div>
      );
    };

    const renderUserName = (ste: string, firstname: string, lastname: string) => {
      return (
        <div className="col-md-3 col-3 pr-0 pa0Mobile">
          <div className="text-uppercase bold">{ste}</div>
          <span className="text-capitalize">{firstname}</span>&nbsp;<span className="text-uppercase">{lastname}</span>
        </div>
      );
    };

    const renderAddress = (address: Address) => {
      return (
        <div className="d-flex flex-column-mobile">
          {renderLibelle(address.libelle, address.is_facturation, address.is_favorite)}
          {renderUserName(address.societe, address.prenom, address.nom)}
          {renderAddressStreet(address)}
          {renderAddressAction(address)}
        </div>
      );
    };
    // Seuls les adresses de livraison sont afichées
    const renderListAddresses = this.state.addresses.map((address: Address) => {
      return (
        <div key={address.id} className="row-address p-3 font14">
          {renderAddress(address)}
        </div>
      );
    });

    const displayListAdresses = () => {
      if (this.state.addresses.length > 0) {
        return renderListAddresses;
      }

      return (
        <p className="text-center bold font16 border border-black p-1 mt-5 mt7">
          Vous n'avez aucune adresse dans votre carnet. </p>
      );
    };

    const renderAddAddress = () => {
      if (this.state.addresses.length < 100) {
        return (
          <div>
            <Link to={'/addresses/address'} className="black linkAddAddress">
            <span>
              <Icons icon="add_circle_outline" size={15} color="black"/>
            </span>
              <span className="pl-1 text-underline">Ajouter une nouvelle adresse</span>
            </Link>
          </div>
        );
      }
      return (
        <div>
          <p>Vous avez atteint le nombre autorisé d'adresses maximum.</p>
        </div>
      );
    };

    const renderPendingOrderMessage = () => {
      if (this.state.pending) {
        return (
          <div className="my-3">
            <p className="p-3 text-center alert-warning font14 m-0">
                <span className="bold">
                  Attention, la modification des adresses dans votre carnet d'adresses n'impacte pas vos commandes
                  en cours.
                </span>
              <br/>
              Dans ce cas, la modification d'adresses est possible via la page&nbsp;
              <Link to={'/orders/'}>
                Mes commandes.
              </Link>
            </p>
          </div>
        );
      }
    };

    return (
      <div>
        <div>
          {renderTitleH1('carnet', 'Mon carnet d\'adresses')}
          {renderFilArianne('', 'Mon carnet d\'adresses')}
          {renderAddAddress()}
        </div>
        {renderAlert(this.state.showAlert, this.state.classAlert, this.state.textAlert)}
        {renderPendingOrderMessage()}
        <div className="mt3 containerAddresses">
          {displayListAdresses()}
        </div>
      </div>
    );
  }
}
